'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const TickIncrementCalculator=require('../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');
const Formatters=require('../../../../dist-es6/client/formatters');

function _formatterFor(increment){
if(increment.interval==='hours'||
increment.interval==='days'){
return Formatters.localAxisTimeLabel;
}
return function(){return''};
}let

TimeAxisLabelDirective=function(_BaseControllerBacked){_inherits(TimeAxisLabelDirective,_BaseControllerBacked);function TimeAxisLabelDirective(){_classCallCheck(this,TimeAxisLabelDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TimeAxisLabelDirective,[{key:'objectBindings',get:function()
{return['axis']}},{key:'controller',get:function()
{return TimeAxisLabelDirectiveController}}]);return TimeAxisLabelDirective}(BaseControllerBackedDirective);let


TimeAxisLabelDirectiveController=function(_BaseResizableDirecti){_inherits(TimeAxisLabelDirectiveController,_BaseResizableDirecti);_createClass(TimeAxisLabelDirectiveController,null,[{key:'$inject',get:function()
{return['$scope','$element','$window']}}]);

function TimeAxisLabelDirectiveController($scope,$element,$window){_classCallCheck(this,TimeAxisLabelDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));
_this2._tickIncrementCalculator=new TickIncrementCalculator;
_this2._svgElement=null;

$scope.$watch('controller.axis.scale',function(){return _this2._render()});
$scope.$watch('controller.dimensions.width',function(){return _this2._render()});return _this2;
}TimeAxisLabelDirectiveController.prototype.

_render=function _render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.axis)||!_.exists(this.axis.scale)){
return;
}

this._refreshSvg();

let spaceBetweenMinorTicks=80;
let idealMinorTicks=this.dimensions.width/spaceBetweenMinorTicks;
let tickIncrements=this._tickIncrementCalculator.calculate(this.axis.domain.duration,idealMinorTicks);

let xAxisGroup=d3.select(this._svgElement).append('g').attr({
class:'x-axis',
transform:`translate(0, ${this.dimensions.height})`}).
call(this._drawTimeAxis(tickIncrements.major));

xAxisGroup.
selectAll('line').
data(this.axis.scale.ticks(d3.time[tickIncrements.minor.interval],tickIncrements.minor.step),_.identity).
enter().
append('line').
attr({
class:'minor',
y1:0,
y2:-3,
x1:this.axis.scale,
x2:this.axis.scale});


xAxisGroup.
selectAll('text').
style({
"text-anchor":'start'});

};TimeAxisLabelDirectiveController.prototype.

_drawTimeAxis=function _drawTimeAxis(majorTickIncrement){
return d3.svg.axis().
scale(this.axis.scale).
orient('top').
ticks(d3.time[majorTickIncrement.interval],majorTickIncrement.step).
innerTickSize(7).
outerTickSize(1).
tickFormat(_formatterFor(majorTickIncrement));
};TimeAxisLabelDirectiveController.prototype.

_refreshSvg=function _refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
};return TimeAxisLabelDirectiveController}(BaseResizableDirectiveController);


module.exports=TimeAxisLabelDirective;
//# sourceMappingURL=timeAxisLabelDirective.js.map
